export default {
    "drawer.instructions": "Instructions",
    "drawer.datasets": "Datasets",
    "user.firstName": "First Name",
    "user.register": "Register",
    "user.lastName": "Last Name",
    "user.email": "Email",
    "user.username": "Username",
    "dataset.name": "Dataset Name",
    "dataset.status": "Dataset Status",
    "dataset.last_modified_at_from": "Modified after",
    "dataset.last_modified_at_to": "Modified before",
    "dataset.description": "Description",
    "dataset.isPublic": "Public Dataset",
    "remove_filters": "Remove filters",
    "termsOfUse": "Terms of Use",
    "privacyPolicy": "Privacy Policy",
    "submit": "Submit",
    "cancel": "Cancel",
    "login": "Login",
    "register": "Register",
    "logout": "Log Out",
    "my_profile": "My Profile",
    "myProfile": "My Profile",
    "csv": "CSV",
    "dataStructure": "Data Structure",
    "preview": "Preview",
    "version": "Version",
    "modified": "Modified",
    "posted": "Posted",
    "description": "Description",
    "dataUrl": "Data URL",
    "dynamicFilterDate": "Date",
    "dynamicFilterStart": "Start",
    "dynamicFilterEnd": "End",
    "dynamicFilterRangeOrderInvalid": "\"End\" must not be before \"Start\".",
    "dynamicFilterKeywordYESTERDAY": "Yesterday",
    "dynamicFilterKeywordLAST_WEEK": "Last week",
    "dynamicFilterKeywordLAST_MONTH": "Last month",
    "dynamicFilterKeywords": "Keywords",
    "portal": "Portal",
    "userProfile.userInfo": "User Info",
    "user_profile.user_info": "User Info",
    "userProfile.changePassword": "Change Password",
    "user_profile.change_password": "Change Password",
    "userProfile.profile": "Profile",
    "lengthExceededError": "Length exceeded",
    "requiredField": "This field is required",
    "columnDescriptions": "Column Descriptions",
    "dataset": "Dataset",
    "title.filter": "Filter",
    "id": "ID",
    "copyToClipboard": "Copy to Clipboard",
    "toast.success": "Success",
    "toast.error": "Error",
    "user.registered": "User registered, check your email for confirmation.",
    "user.registration_error": "User registration failed.",
    "user.registration_409_error": "User with this email or username already exists.",
};
